import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { PublicationsAndSalesDashboardContainerProps } from "../../../../interfaces/containers";
import PublicationsAndSales from "../../../../pages/Profile/Dashboard/PublicationsAndSales";
import { getPublicationsSales, cleanPublicationsSales } from "../../../../actions/dashboard";

function mapStateToProps(state: PublicationsAndSalesDashboardContainerProps) {
    return {
        user: state.auth.user,
        branch: state.profile.dashboard.branch,
        date: state.profile.dashboard.date,
        publicationsAndSales: state.profile.dashboard.publicationsAndSales
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getPublicationsSales, 
        cleanPublicationsSales
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationsAndSales);